export default __webpack_public_path__ + "static/BasierCircle-Medium-36017334eadda27af43acc1ac4b34977.woff2";